// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import AuditHeroImg from "../../asset/Accounting.png";       // Hero background image (replace if needed)
// import AuditCenterImg from "../../asset/image1.png";         // Center image for Audit & Assurance
// import AuditRightImg from "../../asset/image6.png";          // Right-side image for services section
// import LineImg from "../../asset/line1.png";                 // Line image
// import pointImg from "../../asset/point.png";                // Icon for points
// import "./ServiceBusiness.css";                    // Create or reuse existing CSS

// const ServiceAuditAssurance = () => {
//   return (
//     <div>
//       {/* Hero Section */}
//       <div
//         className="services-hero"
//         style={{
//           backgroundImage: `url(${AuditHeroImg})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           height: "88vh",
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           textAlign: "center",
//         }}
//       >
//         {/* Dark Overlay */}
//         <div className="services-overlay"></div>
      
//         {/* Hero Content */}
//         <div className="services-content">
//           <h1 className="services-heading">Building Trust Through Transparency</h1>
//           <p className="services-paragraph">
//             We deliver through audits and assurance services that enhance credibility,
//             accuracy and confidence for your stakeholders.
//           </p>
//         </div>
//       </div>


//       {/* Audit & Assurance Image Section */}
//       <div className="detail-section">
//         <Container className="text-center">
//           <div className="d-flex align-items-center justify-content-center flex-wrap">
//             <img src={LineImg} alt="line-left" className="side-line" />

//             <div className="center-image-wrapper">
//               {/* <img
//                 src={AuditCenterImg}
//                 alt="Audit & Assurance Services"
//                 className="side-image"
//               /> */}
//               <div className="image-text">Audit & Assurance</div>
//             </div>

//             <img src={LineImg} alt="line-right" className="side-line mirrored" />
//           </div>
//         </Container>
//       </div>

//       {/* Service Points Section */}
//       <div className="service-image-section">
//         <Container>
//           <Row className="align-items-center">
//             {/* Left Column with Points */}
//             <Col md={6}>
//               <ul className="service-points">
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Statutory Audit (Public & Private Companies)
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Tax Audit u/s 44AB and other sections
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Internal, Concurrent & Process Audits
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Revenue & Branch Audit of Banks
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Audit of Trusts, Societies, Schools & NGOs
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Information Systems Audit
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Inspection & Investigation Audits
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Establishment & Review of Internal Controls
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Government Department Audits
//                 </li>
//               </ul>
//             </Col>

//             {/* Right Column with Image */}
//             <Col md={6} className="text-center text-md-end">
//               <img
//                 src={AuditRightImg}
//                 alt="Audit & Assurance Detail"
//                 className="service-right-image"
//               />
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </div>
//   );
// };

// export default ServiceAuditAssurance;
import React, { memo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AuditHeroImg from "../../asset/Accounting.webp";       // Hero background
import AuditRightImg from "../../asset/Auditservice.webp";          // Right-side image
import LineImg from "../../asset/line1.png";                // Line image
import pointImg from "../../asset/point.png";               // Icon for points
import "./ServiceBusiness.css";

// ✅ Reusable point item
const ServicePoint = memo(({ text }) => (
  <li>
    <img src={pointImg} alt="icon" className="point-icon" loading="lazy" />
    {text}
  </li>
));

const ServiceAuditAssurance = () => {
  const servicePoints = [
    "Statutory Audit (Public & Private Companies)",
    "Tax Audit u/s 44AB and other sections",
    "Internal, Concurrent & Process Audits",
    "Revenue & Branch Audit of Banks",
    "Audit of Trusts, Societies, Schools & NGOs",
    "Information Systems Audit",
    "Inspection & Investigation Audits",
    "Establishment & Review of Internal Controls",
    "Government Department Audits",
  ];

  return (
    <div>
      {/* Hero Section */}
      <div className="services-hero audit-hero"
        style={{
    backgroundImage: `url(${AuditHeroImg})`, // ✅ Use template literal with imported image
  }}
      >
        <div className="services-overlay"></div>
        <div className="services-content">
          <h1 className="services-heading">Building Trust Through Transparency</h1>
          <p className="services-paragraph">
            We deliver through audits and assurance services that enhance credibility,
            accuracy and confidence for your stakeholders.
          </p>
        </div>
      </div>

      {/* Audit & Assurance Center Section */}
      <div className="detail-section">
        <Container className="text-center">
          <div className="d-flex align-items-center justify-content-center flex-wrap">
            <img src={LineImg} alt="line-left" className="side-line" loading="lazy" />
            <div className="center-image-wrapper">
              <div className="image-text">Audit & Assurance</div>
            </div>
            <img src={LineImg} alt="line-right" className="side-line mirrored" loading="lazy" />
          </div>
        </Container>
      </div>

      {/* Service Points Section */}
      <div className="service-image-section">
        <Container>
          <Row className="align-items-center">
            {/* Left Column */}
            <Col md={6}>
              <ul className="service-points">
                {servicePoints.map((point, index) => (
                  <ServicePoint key={index} text={point} />
                ))}
              </ul>
            </Col>

            {/* Right Column */}
            <Col md={6} className="text-center text-md-end">
              <img
                src={AuditRightImg}
                alt="Audit & Assurance Detail"
                className="service-right-image"
                loading="lazy"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default memo(ServiceAuditAssurance);
